enum EppoFlags {
  DeliveryPerformanceReporting = 'Delivery::ShowDeliveryPerformanceReporting',
  SmokeTestFF = 'EzManage::SmokeTestFF',
  SmokeTestExperiment = 'EzManage::SmokeTestExperiment',
  SelfServePromoTool = 'EzManage::SelfServePromoTool',
  OnboardingNetNewSingleLocation = 'GuidedOnboarding::NetNewSingleLocation',
  PromosReportingDashboard = 'SupplierMarketing::PromosReportingDashboard',
  CustomerEngagementChart = 'SupplierMarketing::CustomerEngagementChart',
  RockstarConvertsToRolling90Days = 'FX::RockstarConvertsToRolling90Days',
  DisallowItemDescriptionOnBrandIDs = 'EzManage::DisallowItemDescriptionOnBrandIDs',
  DisplayItemDescription = 'EzManage::DisplayItemDescription',
  RockstarPreview = 'FX::RockstarPreview',
  PauseAndResumeCampaignGroups = 'SupplierMarketing::PauseAndResumeCampaignGroups',
  TurnOffIntegrationsPermission = 'EzManage::TurnOffIntegrationsPermission',
  PerformanceMetrics = 'SupplierMarketing::PerformanceMetrics',
  ReadFromOrdersSdkForOrderDetails = 'SupplierSelfService::ReadFromOrdersSdkForOrderDetails',
  SponsoredPromoDetails = 'SupplierMarketing::SponsoredPromoDetails',
  TrackedDeliveryPercentNewCopy = 'FX::TrackedDeliveryPercentNewCopy',
  DirectOnboarding = 'SupplierSelfService::DirectOnboarding',
}

export default EppoFlags;
